import { Block } from "@/backend/models/block";
import { Container } from "@/backend/models/containers/container";
import { useBlockStore } from "@/frontend/store/BlockStore";
import { useTreeStore } from "@/frontend/store/TreeStore";
import { blockErrorCheck } from "@/frontend/utils/blockErrorCheck";
import { I18n } from "@/i18n/I18n";
import { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import { useLocation } from "react-router-dom";
import { BlockSearch } from "./BlockSearch";
import { BlockModalItem } from "./BlockModalItem";
import { ProcedureInstanceBase } from "@/backend/models/procedureInstances/procedureInstanceBase";
import { ImplementationFunction } from "@/backend/models/implementationFunction";


type ErrorLookup = { [key: string]: string };

export function BlockModal(props: { setShow: (arg: boolean) => void, parent: Block | Container | ProcedureInstanceBase | ImplementationFunction, position: number, isScaffold?: boolean }) {
  const { setShow, parent, position, isScaffold } = props;
  const blocks = useBlockStore(state => state.blocks);
  const tree = useBlockStore(state => state.tree);
  const location = useLocation();
  const rootId = useTreeStore(state => state.rootId);
  const containerLookup = useTreeStore(state => state.containerLookup);
  const [blockList, setBlockList] = useState(blocks);
  const [blockErrorLookup, setBlockErrorLookup] = useState({} as ErrorLookup);

  const sortFn = (firstBlock: Block, secondBlock: Block) => {
    const firstBlockError = blockErrorLookup[firstBlock.id];
    const secondBlockError = blockErrorLookup[secondBlock.id];
    if (firstBlockError && !secondBlockError) {
      return 1;
    }
    if (secondBlockError && !firstBlockError) {
      return -1;
    }
    return 0;
  };

  useEffect(() => {
    blocks.forEach((block) => {
      const error = blockErrorCheck(tree[block.id], parent, location.pathname, containerLookup, rootId);
      blockErrorLookup[block.id] = error;
    });
    setBlockErrorLookup({ ...blockErrorLookup });
    blocks.sort(sortFn);
    setBlockList(blocks);
  }, [blocks]);

  return (
    <Modal show onHide={() => setShow(false)}>
      <Modal.Header closeButton>
        <Modal.Title>{I18n.get('selectBlock')}</Modal.Title>
      </Modal.Header>
      <Modal.Body style={ {height: '500px', overflow: 'auto' }}>
        <BlockSearch setBlockList={setBlockList} />
        { blockList.map((block) =>
          <BlockModalItem blockId={block.id} parent={parent} position={position} setShow={setShow} error={blockErrorLookup[block.id]} key={`block-${block.id}`} isScaffold={isScaffold} />
        )}
      </Modal.Body>
    </Modal>
  );
}
